import React, { useState, useRef, useEffect } from "react";

const Tooltip = ({ children, text, maxWidth = "200px" }) => {
  const [visible, setVisible] = useState(false);
  const [direction, setDirection] = useState("top");
  const wrapperRef = useRef(null);
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (visible && wrapperRef.current && tooltipRef.current) {
      const wrapperRect = wrapperRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const space = {
        top: wrapperRect.top,
        bottom: window.innerHeight - wrapperRect.bottom,
        left: wrapperRect.left,
        right: window.innerWidth - wrapperRect.right,
      };

      const bestDirection = Object.entries(space)
        .sort((a, b) => b[1] - a[1])[0][0];

      setDirection(bestDirection);
    }
  }, [visible]);

  const tooltipStyle = {
    position: "absolute",
    padding: "8px",
    backgroundColor: "#333",
    color: "#fff",
    borderRadius: "4px",
    fontSize: "0.85rem",
    minWidth: "250px",
    maxWidth: "50vw",
    zIndex: 1000,
    whiteSpace: "normal",
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
  };

  const getPositionStyle = () => {
    switch (direction) {
      case "top":
        return { bottom: "100%", left: "50%", transform: "translateX(-50%)", marginBottom: "8px" };
      case "bottom":
        return { top: "100%", left: "50%", transform: "translateX(-50%)", marginTop: "8px" };
      case "left":
        return { right: "100%", top: "50%", transform: "translateY(-50%)", marginRight: "8px" };
      case "right":
        return { left: "100%", top: "50%", transform: "translateY(-50%)", marginLeft: "8px" };
      default:
        return {};
    }
  };

  return (
    <div
      ref={wrapperRef}
      style={{ position: "relative", display: "inline-block", overflow: "visible" }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div ref={tooltipRef} style={{ ...tooltipStyle, ...getPositionStyle() }}>
          {typeof text === "string" ? <span>{text}</span> : text}
        </div>
      )}
    </div>
  );
};

export default Tooltip;